import { BorderType, PaddingType, AlignType } from 'common/types/styleTypes'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { useFontFamily } from '../use-typography/use-font-family'
import { useFontSize } from '../use-typography/use-font-size'
import { useLineHeight } from '../use-typography/use-line-height'
import { useTextAlign } from '../use-typography/use-text-align'
import { useLetterSpacing } from '../use-typography/use-letter-spacing'
import { usePadding } from '../use-padding'
import { useBorder } from '../use-border'

export const useFormField = ({
  border,
  mobileBorder,
  padding,
  mobilePadding,
  fontFamily,
  mobileFontFamily,
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
}: {
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  padding?: PaddingType
  mobilePadding?: PaddingType
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
}) => {
  const returnUsePadding = usePadding({
    padding,
    mobilePadding,
    type: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseBorder = useBorder({
    border,
    mobileBorder,
    type: WebsiteSettingsTypographyTypeEnum.FormField,
  })
  const returnUseFontFamily = useFontFamily({
    fontFamily,
    mobileFontFamily,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseFontSize = useFontSize({
    fontSize,
    mobileFontSize,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseLineHeight = useLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseTextAlign = useTextAlign({
    textAlign,
    mobileTextAlign,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseLetterSpacing = useLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  return {
    ...returnUsePadding,
    ...returnUseBorder,
    ...returnUseFontSize,
    calculatedFontSize: {
      mobile: returnUseFontSize.calculatedFontSize.mobile as number,
      desktop: returnUseFontSize.calculatedFontSize.desktop as number,
    },
    ...returnUseLineHeight,
    ...returnUseTextAlign,
    ...returnUseLetterSpacing,
    ...returnUseFontFamily,
  }
}
